
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return require("private-next-pages/blog/[slug]/index.tsx");
      }
    ]);
  